import { render, staticRenderFns } from "./JoinAppointmentTooltip.vue?vue&type=template&id=118d77be&scoped=true&"
import script from "./JoinAppointmentTooltip.vue?vue&type=script&lang=ts&"
export * from "./JoinAppointmentTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./JoinAppointmentTooltip.vue?vue&type=style&index=0&id=118d77be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118d77be",
  null
  
)

export default component.exports